module.exports = __webpack_public_path__ + "staticesp/media/marcas (2).bce9e703.jpg";